import React, { useEffect, useState } from 'react';
import { Typography, Box, Grid, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ReportBasicInfo from '../../_common/Report/ReportBasicInfo';
import ResultTable, {
  CategoryResultTable,
} from '../../_common/Report/ResultTable';
import ReportDtaImage from '../../_common/Report/ReportDtaImage';
import {
  HEADER_HEIGHT,
  PRINT_REPORT_BREAK_AVOID,
  PRINT_REPORT_NOT_DISPLAY,
  PRINT_REPORT_PAGE,
} from '../../_constants/styleConst';
import { useLocation, useNavigate } from 'react-router-dom';
import { NavigateReportFormat } from '../../types/NavigateOptionType';
import { INSPEX_PATHNAME } from '../../_constants/Const';

/** 帳票フォーマット画面 */
const ReportFormat: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigateOption = location.state as NavigateReportFormat;
  const [documentNo, setDocumentNo] = useState<string>('');
  const [effectiveDate, setEffectiveDate] = useState<string>('');
  const [title, setTitle] = useState<string>('');
  const [formatTables, setFormatTables] = useState<CategoryResultTable[][]>([]);
  const [isDisplay, setIsDisplay] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (navigateOption) {
      setTitle(navigateOption.title);
      setDocumentNo(navigateOption.documentNo);
      setEffectiveDate(navigateOption.effectiveDate);
      setFormatTables(navigateOption.formatTables);
      setIsDisplay(true);
    }
  }, []);

  const onClickDownload = () => {
    // titleを一時的に保存するファイル名に置き換える
    const documentTitle = document.title;
    document.title = title;
    window.print();
    document.title = documentTitle;
  };

  return (
    <Box
      mx="2rem"
      sx={[
        PRINT_REPORT_PAGE,
        {
          whiteSpace: 'pre-wrap !important',
          wordWrap: 'break-word !important',
        },
      ]}
    >
      <Box
        sx={[PRINT_REPORT_NOT_DISPLAY, { mt: `calc(${HEADER_HEIGHT} + 1rem)` }]}
      />
      {isDisplay && (
        <Box
          sx={{
            overflow: 'auto',
            height: `calc(100dvh - ${HEADER_HEIGHT} - 90px)`,
            '@media print': {
              overflow: 'visible !important',
              height: 'auto !important',
              maxHeight: 'none !important',
            },
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography pt="1rem" variant="h3">
              {t('LBL_INSPECTION_SHEET')}
            </Typography>
            <Box
              display="flex"
              flexDirection="column"
              mt="2rem"
              border="solid 1px"
              sx={{ minWidth: '270px' }}
            >
              <Grid container spacing={1}>
                <Grid
                  size={12}
                  sx={{ display: 'flex' }}
                  style={{ padding: '5px 2px' }}
                  borderBottom={'solid 1px'}
                >
                  <Typography>{`${t('LBL_DOCUMENT_NO')} : `}</Typography>
                  <Typography>{documentNo}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid
                  size={12}
                  sx={{ display: 'flex' }}
                  style={{ padding: '5px 2px' }}
                >
                  <Typography>{`${t('LBL_EFFECTIVE_DATE')} : `}</Typography>
                  <Typography>{effectiveDate}</Typography>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <ReportBasicInfo
            rmaNo={''}
            serialNo={''}
            model={''}
            customerName={''}
            originalCustomer={''}
            inspector={''}
            qcInspector={''}
            inspectionDate={''}
            qcDate={''}
            qcCount={-1}
            isInspectionSerialChecked={undefined}
            isQcSerialChecked={undefined}
          />
          <Box display="flex" justifyContent="space-between" mt="2rem">
            <Box width="50%" mr={'5px'}>
              {formatTables[0] && (
                <ResultTable tableData={formatTables[0]} isPreview={true} />
              )}
            </Box>
            <Box width="50%" ml={'5px'}>
              {formatTables[1] && (
                <ResultTable tableData={formatTables[1]} isPreview={true} />
              )}
              <ReportDtaImage markers={[]} repairRequest={undefined} />
            </Box>
          </Box>
          <Box my={3} sx={PRINT_REPORT_BREAK_AVOID}>
            <Typography
              pl={1}
              pt={1}
              fontSize={'0.7rem'}
              fontWeight={400}
              color="grey.500"
            >
              {t('LBL_MEMO')}
            </Typography>
            <Box
              border={1}
              borderColor={'grey.500'}
              borderRadius={'4px'}
              p={'16px 14px'}
              sx={{ minHeight: '120px' }}
            />
          </Box>
        </Box>
      )}
      <Box
        sx={[
          PRINT_REPORT_NOT_DISPLAY,
          { position: 'fixed', bottom: 0, width: `calc(100vw - 4rem)` },
        ]}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            my: '1rem',
          }}
        >
          <Button
            sx={{
              p: '0.5rem 1.5rem',
              minWidth: '200px',
            }}
            variant="outlined"
            onClick={() => {
              navigate(INSPEX_PATHNAME.MANAGE_TEMPLATE);
            }}
          >
            {t('BTN_BACK')}
          </Button>

          <Button
            sx={{
              p: '0.5rem 1.5rem',
              minWidth: '200px',
            }}
            variant="outlined"
            onClick={() => onClickDownload()}
            disabled={!isDisplay}
          >
            {t('BTN_PRINT')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
export default ReportFormat;
